import { type ReactElement } from "react";
import { Chip } from "@citibox-panel/ui";
import { Row } from "./DemoScaffold";

export function ChipDemo(): ReactElement {
  return (
    <Row>
      <Chip label="Activo" color="success" />
      <Chip label="Bloqueado" color="error" />
      <Chip label="Desconocido" />
      <Chip label="Outlined" variant="outlined" />
    </Row>
  );
}
